<script setup lang="ts">
defineProps<{
  fieldsetMainName?: string
  fieldsetLegends?: string[]
}>()
</script>
<template>
  <div class="flex flex-col gap-4">
    <h3 v-if="fieldsetMainName" class="text-base font-semibold sm:text-lg">
      {{ fieldsetMainName }}
    </h3>
    <div class="space-y-10 rounded-md border p-4 sm:p-5">
      <fieldset v-for="(legend, index) in fieldsetLegends" :key="legend" class="space-y-5">
        <div class="text-md space-y-2 font-medium leading-6 text-foreground">
          <legend v-if="$slots[`legend${index + 1}`]">
            <slot :name="`legend${index + 1}`"></slot>
          </legend>
          <legend v-else>
            {{ legend }}
          </legend>
          <slot :name="index + 1"></slot>
        </div>
      </fieldset>
    </div>
  </div>
</template>
